"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const sulu_1 = require("../../api/sulu");
const noop_1 = require("../../common/js/helper/noop");
const configuration_1 = require("../apis/configuration/sulu/configuration");
const UiStore_1 = __importDefault(require("./UiStore"));
class ResellerAreaNavigationStore {
    api = new sulu_1.ResellerApi(configuration_1.authenticatedConfiguration);
    loading = false;
    pageNeedsNavigationItem = new Map();
    navigationItems = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            isLoading: mobx_1.computed,
            items: mobx_1.computed,
            loading: mobx_1.observable,
            navigationItems: mobx_1.observable,
            loadNavigation: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.loading;
    }
    needsNavigationItem(path) {
        return this.pageNeedsNavigationItem.get(path) === true;
    }
    get items() {
        return this.navigationItems;
    }
    loadNavigation() {
        this.loading = true;
        return this.api
            .getResellerNavigation({ locale: UiStore_1.default.language })
            .then((0, mobx_1.action)((navigationItems) => {
            this.navigationItems = navigationItems;
        }))
            .then(() => {
            return Promise.all(Object.values(this.navigationItems).map((navItem) => {
                if (navItem.children.length > 0) {
                    return this.api
                        .getResellerPage({ pathname: navItem.pathname, locale: UiStore_1.default.language })
                        .then((page) => {
                        this.pageNeedsNavigationItem.set(page.pathname, page.content.length > 0);
                    });
                }
            })).then(noop_1.noop);
        })
            .finally((0, mobx_1.action)(() => {
            this.loading = false;
        }));
    }
}
exports.default = new ResellerAreaNavigationStore();
